import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type="number"]' // Apply this directive to all input elements of type number
})
export class BlurOnMousewheelDirective {

  constructor(private el: ElementRef) {}

  @HostListener('mousewheel', ['$event'])
  onMouseWheel(event: WheelEvent): void {
    this.el.nativeElement.blur();
  }
}
